// Material Kit 2 React pages
import AdministrativeStaff from "pages/AdministrativeStaff";

export default function AdministrativeStaffView() {
  return <AdministrativeStaff />;
}
